import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconTranslateProps } from './IconTranslate.types'
import * as Styled from './styles/IconTranslate.style'

import { nonThemeableRules } from '../../ruleSet'

const IconTranslate: FC<IconTranslateProps> = ({
  size = nonThemeableRules.defaultSize as number as IconTranslateProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconTranslateProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path d='M6.508 7.516h5.023M8.492 6.484v1.032m1.172 0c-.043.14-1.613 4.25-4.223 5.011' vectorEffect='non-scaling-stroke' />
          <path
            d='M7.55 9.082c.419.7 1.56 2.145 2.95 2.918m5.016-.48 2.449 6.023m-4.899 0 2.45-6.023m-1.828 4.496h3.656'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M13.508 9.492V4.523H5.477c-1.106 0-2 .899-2 2v6.02a2 2 0 0 0 2 2H10.5' vectorEffect='non-scaling-stroke' />
          <path
            d='M20.535 17.527c0 1.102-.898 2-2 2H12.5c-1.105 0-2-.898-2-2v-5.992a2 2 0 0 1 2-2h8.035Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconTranslate
